import { GridColumnHeaderParams } from "@mui/x-data-grid";

const CustomColumnHeader = (props: GridColumnHeaderParams) => {
  return (
    <div className="MuiDataGrid-columnHeaderTitle">
      {props.colDef.headerName}
    </div>
  );
};

export default CustomColumnHeader;
